// generated from 57 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceIdfaFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_idfa_filter"),
  comparison_key: z.enum([
    "11", // 28 (49.12%)
    "1", // 10 (17.54%)
    "17", // 10 (17.54%)
    "12", // 5 (8.77%)
    "2", // 4 (7.02%)
  ]),
  display_name: z.string(),
  // undefined: 32 (56.14%), defined 25 (43.86%)
  // format uuid: 8 (32.00%)
  raw_value: z.string().optional(),
  // format integer: 14 (24.56%)
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
